import GrailedAPIError from "storefront/GrailedAPI/Error";

/**
 * Every GrailedAPIError is constructed in one shared helper, so all of them reach Sentry with an
 * identical two-frame stack. Sentry groups by stack, so unrelated endpoints and statuses collapse
 * into a single issue that can never be meaningfully resolved. Grouping by status and path splits
 * them apart; the query string is dropped so one endpoint does not fan out into an issue per
 * distinct set of params.
 */
export const fingerprintGrailedAPIError = (
  error: GrailedAPIError,
): Array<string> | undefined => {
  const { status, url } = error.response;
  if (!status || !url) return undefined;

  // The base only matters for relative urls, whose pathname is all we keep anyway.
  let path: string;
  try {
    path = new URL(url, "http://localhost").pathname;
  } catch {
    return undefined;
  }

  return ["GrailedAPIError", String(status), path];
};
